import axios from '@/shared/utils/axios-init';

/* eslint-disable */
const initialState = {
  clockTimestamp: null,
  navMenu: false,
  locale: {},
  languages: [],
  countries: [],
};

const getters = {
  getClockTimestamp: (state) => state.clockTimestamp,
  getNavMenuState: (state) => state.navMenu,
  getLocale: (state) => state.locale,
  getLanguages: (state) => state.languages,
};

const mutations = {
  setClockTimestamp(state, timestamp) {
    state.clockTimestamp = timestamp;
  },
  toggleNavmenu(state, menuState) {
    state.navMenu = menuState;
  },
  setLocale(state, data) {
    state.locale[data.lang] = data.data;
  },
  setLanguages(state, data) {
    state.languages = data;
  },
  setCountries(state, data) {
    state.countries = data;
  },
};

const actions = {
  async fetchClockTimestamp({ commit }) {
    const data = await axios('settings');
    const timestamp = data.data.server_time;

    commit('setClockTimestamp', timestamp);
  },
  async fetchLocaleData({ commit }, credentials) {
    try {
      const data = await axios.post(
        '/translate',
        JSON.stringify({ lang: credentials.lang })
      );
      const localeData = data.data.trans_data;

      commit('setLocale', { lang: credentials.lang, data: localeData });
      return localeData;
    } catch (error) {
      return error.response;
    }
  },
  async fetchLanguagesData({ commit }) {
    try {
      const data = await axios.get('/languages');
      const languagesData = data.data.data;

      commit('setLanguages', languagesData);
      return languagesData;
    } catch (error) {
      return error.response;
    }
  },
  async fetchCountries({ commit }) {
    try {
      const lang = localStorage.getItem('language');
      const { data } = await axios.get('/countries', { params: { lang } });

      if (!data.success) throw new Error('Something went wrong');

      const countries = Object.keys(data.countries).map((key) => {
        return { value: key, name: data.countries[key] };
      });

      commit('setCountries', countries);
    } catch (err) {
      console.log(err);
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/shared/store/modules/global.js